import { format, parse } from 'date-fns';

import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';

import { SravniReviewsModelsReviewReviewUpdateValidatableModel } from '../../../__generated__/reviews/reviewsApiTypes';
import { CUSTOMER_TYPE_TO_BOOLEAN } from '../../../constants/reviews';
import { IReviewCreateBody } from '../../../interfaces/reviews';
import { DATE_FORMAT_FOR_CREATING_REVIEW } from '../../../utils/dateTime';
import { dateFormat } from '../../../utils/yup';
import { REVIEW_FIELDS } from '../constants/common';
import { TPrepareSubmitDataParams } from '../types';

export const prepareSubmitData = (params: TPrepareSubmitDataParams): IReviewCreateBody => {
  const { data, initReview, isEdit, query, fingerPrint, product } = params;

  const utm = query && {
    ...(query.utm_source && { utmSource: query.utm_source }),
    ...(query.utm_campaign && { utmCampaign: query.utm_campaign }),
    ...(query.utm_medium && { utmMedium: query.utm_medium }),
  };

  // ************ Формирование reviewUserData ************
  const {
    [REVIEW_FIELDS.USER_PHONE]: userPhoneForAppeal,
    [REVIEW_FIELDS.USER_NAME]: userNameForAppeal,
    [REVIEW_FIELDS.BIRTHDAY]: userBirthDateForAppealNotFormatted,
  } = data;

  const userBirthDateForAppeal = userBirthDateForAppealNotFormatted
    ? format(parse(userBirthDateForAppealNotFormatted, dateFormat, new Date()), DATE_FORMAT_FOR_CREATING_REVIEW)
    : '';

  const reviewUserData =
    !userNameForAppeal && !userBirthDateForAppeal && !userPhoneForAppeal
      ? null
      : {
          userNameForAppeal,
          userBirthDateForAppeal,
          userPhoneForAppeal,
        };

  // ************ Параметры из изначального отзыва, которые не меняются в форме ************
  const dataFromInitReview: Partial<SravniReviewsModelsReviewReviewUpdateValidatableModel> = {
    isRecommendedByUser: isEdit ? initReview.isRecommendedByUser : true,
    isAboutSravni: isEdit ? initReview.isAboutSravni : false,
    ...(isEdit && {
      id: initReview.id,
      positiveTags: initReview.positiveTags?.map(({ id }) => id),
      negativeTags: initReview.negativeTags?.map(({ id }) => id),
    }),
  };

  const orgHelper = getOrganizationHelpers(data[REVIEW_FIELDS.ORGANIZATION_TYPE]);

  return {
    ...dataFromInitReview,
    locationGarId: data.locationGarId,
    title: data.title,
    text: data.text,
    reviewObjectId: data[REVIEW_FIELDS.ORGANIZATION_ID],
    reviewObjectType: orgHelper.reviewService,
    reviewTag: data[REVIEW_FIELDS.SERVICE],
    messageForCompany: data.messageForCompany,
    attachments: data.attachments,
    rating: data.rating,
    isLegal: CUSTOMER_TYPE_TO_BOOLEAN[data.isLegal],
    specificProductId: data[REVIEW_FIELDS.PRODUCT_ID],
    specificProductName: product?.name,
    reviewUserData,
    utm,
    fingerPrint,
  };
};
